module.exports = "/static/assets/3732270cfcc864cbbd939ae7213f1a5a.svg";